// RYP Golf Brand Theme
export const theme = {
  colors: {
    primary: '#00af51',      // RYP Green
    secondary: '#f4ee19',    // RYP Yellow
    background: {
      primary: '#000000',    // Black background
      secondary: '#1a1a1a',  // Dark gray
      green: '#00af51'       // RYP Green
    },
    text: {
      primary: '#ffffff',    // White text
      secondary: '#cccccc',  // Light gray
      dark: '#000000'        // Black text
    },
    border: '#333333',
    success: '#00af51',
    warning: '#f4ee19',
    error: '#ff4444'
  },
  typography: {
    fontFamily: {
      headline: 'Raleway, sans-serif',
      body: 'Work Sans, sans-serif'
    },
    fontWeights: {
      regular: 400,
      medium: 500,
      semibold: 600,
      bold: 700
    },
    fontSizes: {
      xs: '12px',
      sm: '14px',
      base: '16px',
      lg: '18px',
      xl: '20px',
      '2xl': '24px',
      '3xl': '30px',
      '4xl': '36px',
      '5xl': '48px'
    },
    lineHeights: {
      tight: 1.2,
      normal: 1.5,
      relaxed: 1.75
    }
  },
  spacing: {
    xs: '4px',
    sm: '8px',
    md: '16px',
    lg: '24px',
    xl: '32px',
    '2xl': '48px',
    '3xl': '64px'
  },
  borderRadius: {
    sm: '4px',
    md: '8px',
    lg: '12px',
    xl: '16px'
  },
  shadows: {
    sm: '0 1px 3px rgba(0,0,0,0.12)',
    md: '0 4px 6px rgba(0,0,0,0.1)',
    lg: '0 10px 15px rgba(0,0,0,0.1)',
    green: '0 4px 12px rgba(0, 175, 81, 0.3)'
  }
}; 